"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformGGFilterPropertyToV2 = exports.IssueMigration = exports.IssueFilterPropertyMigration = void 0;
var _omit = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const transformGGFilterPropertyToV2 = property => {
  if (property === "issueTypeCategoryId") {
    return "issueTypeId";
  }
  if (property === "issueTypeId") {
    return "issueSubtypeId";
  }
  return property;
};
exports.transformGGFilterPropertyToV2 = transformGGFilterPropertyToV2;
const IssueFilterPropertyMigration = exports.IssueFilterPropertyMigration = {
  serialize: transformGGFilterPropertyToV2
};
const IssueMigration = exports.IssueMigration = {
  serialize: attributes => ({
    ...(0, _omit.default)(attributes, ["issueTypeId"]),
    issueSubtypeId: attributes.issueTypeId
  }),
  deserialize: v2Issue => {
    return {
      ...(0, _omit.default)(v2Issue, ["issueTypeId", "issueSubtypeId", "containerId", "permittedAttributes"]),
      projectId: v2Issue.containerId,
      issueTypeCategoryId: v2Issue.issueTypeId,
      issueTypeId: v2Issue.issueSubtypeId,
      permittedAttributes: v2Issue.permittedAttributes.map(attribute => {
        if (attribute === "issueSubtypeId") {
          return "issueTypeId";
        }
        if (attribute === "issueTypeId") {
          return "issueTypeCategoryId";
        }
        return attribute;
      })
    };
  }
};
//# sourceMappingURL=IssueMigration.js.map